import React from 'react';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CommuteIcon from '@mui/icons-material/Commute';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import TimerIcon from '@mui/icons-material/Timer';

export const colors = {
  mustard: '#f6b03d',
  gray: '#ebebeb',
  status: '#125c80',
  origin: '#009a97',
  movement: '#8e44ad ',
  undelivered: '#ff005c',
  codeAll: '#073043',
  code1: '#ea5d2c',
  code2: '#f5a334',
  code3: '#59b9d6',
  code999: '#6d6e6e',
  codeCD: '#57b9d6',
  codeUM: '#479bb4',
  product1: '#2196F3',
  product2: '#4CAF50',
  product3: '#FFC107',
  product4: '#F44336',
  product5: '#009688',
  product6: '#FF9800',
  product7: '#E91E63',
  productDefault: '#9E9E9E',
  delay: '#fa0000',
  movement1: '#a569bd',
  movement0: '#d2b4de'
};

export const listStatus = [
  {
    code: 1,
    description: 'Sin asignación',
    color: colors.code1,
    icon: <PostAddIcon fontSize="large" />
  },
  {
    code: 2,
    description: 'En Reparto',
    color: colors.code2,
    icon: <CommuteIcon fontSize="large" />
  },
  {
    code: 3,
    description: 'Con asignación',
    color: colors.code3,
    icon: <LibraryAddCheckIcon fontSize="large" />
  },
  {
    code: 999,
    description: 'Desconocido',
    color: colors.code999,
    icon: <TimerIcon fontSize="large" />
  },
  {
    code: 0,
    description: 'Todos',
    color: colors.codeAll,
    icon: <TimerIcon fontSize="large" />
  }
];

export const listOrigin = [
  {
    code: 'CD',
    description: 'Centro de distribución',
    color: colors.codeCD
  },
  {
    code: 'UM',
    description: 'Útima milla',
    color: colors.codeUM
  },
  {
    code: 'Todos',
    description: 'Todos',
    color: colors.codeAll
  }
];

export const listMovement = [
  {
    code: '0',
    description: 'Sin Movimiento',
    color: colors.movement0
  },
  {
    code: '1',
    description: 'Con Movimiento',
    color: colors.movement1
  },
  {
    code: 'Todos',
    description: 'Todos',
    color: colors.codeAll
  }
];

export const ListProducts = [
  {
    code: [350],
    color: colors.product1
  },
  {
    code: [351],
    color: colors.product1
  },
  {
    code: [401],
    color: colors.product2
  },
  {
    code: [402, 403, 404, 405],
    color: colors.product3
  },
  {
    code: [
      410,
      411,
      412,
      413,
      414,
      415,
      416,
      417,
      418,
      419,
      420,
      421,
      422,
      423,
      424,
      425,
      426,
      427
    ],
    color: colors.product4
  },
  {
    code: [451],
    color: colors.product5
  },
  {
    code: [452],
    color: colors.product6
  },
  {
    code: [460, 461, 462, 463, 464, 465],
    color: colors.product7
  }
];

export const diffDate = (startDate, lastDate) => {
  try {
    // asignar el valor de las unidades en milisegundos
    const msecPerMinute = 1000 * 60;
    const msecPerHour = msecPerMinute * 60;
    const msecPerDay = msecPerHour * 24;

    // Obtener la diferencia en milisegundos
    let interval = new Date(startDate).getTime() - new Date(lastDate).getTime();

    var days = Math.floor(interval / msecPerDay);
    interval = interval - days * msecPerDay;

    const hours = Math.floor(interval / msecPerHour);
    interval -= hours * msecPerHour;

    const minutes = Math.floor(interval / msecPerMinute);
    interval -= minutes * msecPerMinute;

    const seconds = Math.floor(interval / 1000);

    if (days >= 1) {
      return `${days ? `${days} dias ` : ''}${hours ? `${hours} hr ` : ''}`;
    }

    return `${hours ? `${hours} hr ` : ''}${minutes ? ` ${minutes} min ` : ''}${
      seconds ? ` ${seconds} seg` : ''
    }`;
  } catch (e) {
    console.log('Formato incorrecto de fecha en diffDate:', {
      startDate,
      lastDate
    });
    return '';
  }
};

export const REACT_APP_TIME_DRIVER_DISPLACEMENT =
  process.env.REACT_APP_TIME_DRIVER_DISPLACEMENT;

export const formatDataLiveTracking = dataLiveTracking => {
  const msecPerMinute = 1000 * 60;
  let minTime = REACT_APP_TIME_DRIVER_DISPLACEMENT
    ? parseFloat(REACT_APP_TIME_DRIVER_DISPLACEMENT)
    : 0;
  if (dataLiveTracking && dataLiveTracking.length > 0) {
    return dataLiveTracking.map(f => {
      let driversDelayToDisplacement = false;
      if (
        f.currentDriverPosition &&
        f.currentDriverPosition.displacement_recorded_at
      ) {
        let interval =
          new Date().getTime() -
          new Date(f.currentDriverPosition.displacement_recorded_at).getTime();
        const minutes = Math.floor(interval / msecPerMinute);

        if (minutes > minTime) {
          driversDelayToDisplacement = true;
        }
      }

      return {
        ...f,
        driversDelayToDisplacement
      };
    });
  }
};
